import { v4 as uuidv4 } from "uuid";

// OrderedCuts will come from optimizerData.orderedCuts
const getShearingData = (flatSheetSize, orderedCuts, orderedPieces) => {
  let flatSheets = parseSheetsByCuts(Number(flatSheetSize), orderedCuts);

  let { flatSheetsForShearing, shearingInstructions } =
    reorganizeCutsAndFlatsForShearing(
      Number(flatSheetSize),
      flatSheets,
      orderedPieces
    );

  // Shearing Data
  return {
    flatSheetsForShearing,
    shearingInstructions,
  };
};

// Parse Sheets into Cuts
const parseSheetsByCuts = (flatSheetSize, cuts) => {
  if (cuts.length > 0) {
    let sheets = [{ pieces: [] }];
    // For Each Group
    for (let cut of cuts) {
      // Cuts are already in descending stretchout order
      let fsIndex = 0;

      // For Each Cut
      // Find which FS to add the Cut into
      let added = false;
      while (!added) {
        let currentFS = sheets[fsIndex];
        let currentFSUsedWidth = 0;
        for (let fsPiece of currentFS.pieces) {
          currentFSUsedWidth += Number(fsPiece.stretchOut);
        }

        let leftOverWidth = flatSheetSize - currentFSUsedWidth;
        if (leftOverWidth >= cut.stretchOut) {
          sheets[fsIndex].pieces = [
            ...currentFS.pieces,
            {
              name: cut.name,
              stretchOut: cut.stretchOut,
              tempId: uuidv4(),
            },
          ];
          added = true;
        } else {
          if (fsIndex >= sheets.length - 1) {
            sheets.push({
              pieces: [
                {
                  name: cut.name,
                  stretchOut: cut.stretchOut,
                  tempId: uuidv4(),
                },
              ],
            });
            added = true;
          }
          fsIndex++;
        }
      }
    }

    return sheets;
  } else {
    return [];
  }
};

// Create Shearing Instructions From Cuts & FlatSheets
const reorganizeCutsAndFlatsForShearing = (
  flatSheetSize,
  flatSheets,
  orderedPieces
) => {
  // Copy Flat Sheets
  let sheetsCopy = [];
  for (let sheet of flatSheets) {
    let pieces = sheet.pieces;
    sheetsCopy.push({
      ...sheet,
      size: flatSheetSize,
      pieces: pieces.map((object) => ({ ...object })),
    });
  }

  // Generate Shear Instructions
  let instructions = [];

  // Sort Pieces in each flat sheet into descending size
  for (let sheet of sheetsCopy) {
    sheet.pieces.sort((a, b) => {
      if (b.stretchOut - a.stretchOut != 0) {
        return b.stretchOut - a.stretchOut;
      } else {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      }
    });
  }

  // Sort Flat Sheets By Cutting Order
  sheetsCopy.sort((a, b) => {
    let aPieces = a.pieces;
    let bPieces = b.pieces;

    let aIndex = 0;
    let bIndex = 0;
    // Increment index on both arrays until you find a mismatch
    while (aPieces[aIndex].stretchOut == bPieces[bIndex].stretchOut) {
      // If end reached, return negative 1, else get next element
      if (aIndex + 1 >= aPieces.length) {
        return 1;
      }
      // If end reached, return positive 1, else, get next element
      if (bIndex + 1 >= bPieces.length) {
        return -1;
      }

      aIndex++;
      bIndex++;
    }

    return bPieces[bIndex].stretchOut - aPieces[aIndex].stretchOut;
  });
  // setFlatSheetsForShearing(sheetsCopy);

  // Copy the sorted sheets (deep copy without references)
  let flatSheetsCopy = [];
  for (let sheet of sheetsCopy) {
    let pieces = sheet.pieces;
    flatSheetsCopy.push({
      ...sheet,
      size: flatSheetSize,
      pieces: pieces.map((object) => ({ ...object })),
    });
  }

  // Copy Pieces and Order By Stretchout AND Name (if equal stretchout)
  let orderedPiecesCopy = [...orderedPieces];
  orderedPiecesCopy.sort((a, b) => {
    if (Number(b.stretchOut) - Number(a.stretchOut) != 0) {
      return Number(b.stretchOut) - Number(a.stretchOut);
    } else {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    }
  });

  // Iterate Through Trim Types
  for (let orderedPiece of orderedPiecesCopy) {
    let currentPieceName = orderedPiece.name;
    let currentPieceStretchOut = orderedPiece.stretchOut;

    // Iterate Through Flat Sheets
    for (let sheetIndex = 0; sheetIndex < flatSheetsCopy.length; sheetIndex++) {
      let currentSheet = flatSheetsCopy[sheetIndex];
      // console.log("CURRENT SHEET", currentSheet);
      let currentSheetSizeBeforeCutting = currentSheet.size;

      let numberOfPiecesRemoved = 0;

      // Iterate Through Flat Sheet Cuts
      let allPiecesOfCurrentSizeRemovedFromSheet = false;
      let cutIndex = 0;
      while (
        cutIndex < currentSheet.pieces.length &&
        !allPiecesOfCurrentSizeRemovedFromSheet
      ) {
        let currentCut = currentSheet.pieces[cutIndex];
        // console.log({
        //   currentCutName: currentCut.name,
        //   currentPieceName: currentPieceName,

        //   currentCutStretchOut: currentCut.stretchOut,
        //   currentPieceStretchOut: currentPieceStretchOut,
        // });
        if (
          currentCut.name == currentPieceName &&
          Number(currentCut.stretchOut) == Number(currentPieceStretchOut)
        ) {
          // console.log("CURRENT CUT MATCHES NAME AND STRETCHOUT");
          if (currentSheetSizeBeforeCutting < flatSheetSize) {
            // console.log("ADD SHEAR INSTRUCTION");
            // + Add Instruction for Current Piece
            instructions.push(
              `[${currentSheetSizeBeforeCutting}" DROP - FS #${
                sheetIndex + 1
              }] - SHEAR ${currentCut.stretchOut}" - ${currentCut.name}`
            );
          } else {
            // console.log("DONT ADD SHEAR INSTRUCTION");
            // + Add Instruction for Current Piece
            instructions.push(
              `[FS #${sheetIndex + 1}] - SHEAR ${currentCut.stretchOut}" - ${
                currentCut.name
              }`
            );
          }

          // Pop First Element
          numberOfPiecesRemoved++;

          // Reduce FlatSheet Size
          currentSheet.size =
            Number(currentSheet.size) - Number(currentCut.stretchOut);

          // Check If Next Piece Exists
          // console.log("CHECK IF NEXT PIECE EXISTS", cutIndex);
          if (cutIndex + 1 < currentSheet.pieces.length) {
            let nextPiece = currentSheet.pieces[cutIndex + 1];
            // console.log("NEXT PIECE", nextPiece);
            // If next piece is the last piece and is equal to the current sheet size then it no longer needs cutting
            // console.log(
            //   `nextPiece.stretchOut == currentSheet.size`,
            //   `${nextPiece.stretchOut} == ${currentSheet.size}`
            // );
            if (nextPiece.stretchOut == currentSheet.size) {
              instructions.push(
                `[FS #${sheetIndex + 1}] - LAST PIECE ${
                  nextPiece.stretchOut
                }" - ${nextPiece.name}`
              );
              // Pop This Element as well
              numberOfPiecesRemoved++;
              // Reduce FlatSheet Size
              currentSheet.size =
                Number(currentSheet.size) - Number(nextPiece.stretchOut);
              cutIndex++;
            } else {
              // If there is last piece but is not equal to the current sheet size and not equal to the current cut size
              // then save the rest as drop for later
              if (nextPiece.stretchOut != currentCut.stretchOut) {
                if (currentSheetSizeBeforeCutting < flatSheetSize) {
                  instructions.push(
                    `[${currentSheetSizeBeforeCutting}" DROP - FS #${
                      sheetIndex + 1
                    }] - SET ASIDE [${currentSheet.size}" DROP]`
                  );
                } else {
                  instructions.push(
                    `[FS #${sheetIndex + 1}] - SET ASIDE [${
                      currentSheet.size
                    }" DROP]`
                  );
                }
              }
            }
          } else {
            // If there are no more pieces but the sheet size > 0
            // Then the last piece is a drop
            if (currentSheet.size > 0) {
              {
                if (currentSheetSizeBeforeCutting < flatSheetSize) {
                  instructions.push(
                    `[${currentSheetSizeBeforeCutting}" DROP - FS #${
                      sheetIndex + 1
                    }] - DROP ${currentSheet.size}" - put away for future use`
                  );
                } else {
                  instructions.push(
                    `[FS #${sheetIndex + 1}] - DROP ${
                      currentSheet.size
                    }" - put away for future use`
                  );
                }
              }
            }
          }
        } else {
          // console.log("CURRENT CUT DOES NOT MATCH NAME AND STRETCHOUT");
          allPiecesOfCurrentSizeRemovedFromSheet = true;
        }
        cutIndex++;
      }
      // Remove Cuts that were removed from the array
      for (let i = 0; i < numberOfPiecesRemoved; i++) {
        currentSheet.pieces.shift();
      }
    }
  }
  // setShearInstructions(instructions);

  // TODO: Squash/Merge Equivalent Flat Sheets that have the same cuts
  let finalFlatSheets = [];
  let previousSheet = null; // Cut Composition of the Current Sheet
  for (let flatSheet of sheetsCopy) {
    // If current flatSheet matches cut composition of previous sheet composistion, then merge them
    // If current flatSheet does not match, then add to array and set the new currentSheetComposition

    // The flatSheet cuts are already sorted largest to smallest
    // 1. Check if array lengths are the same
    // 2. Compare each element at the same index
    // O(n) for n cuts
    if (previousSheet == null) {
      finalFlatSheets.push({
        count: 1,
        sheetTemplate: flatSheet,
      });
    } else {
      let currentSheetLength = flatSheet.pieces.length;
      let previousSheetLength = previousSheet.pieces.length;
      if (currentSheetLength != previousSheetLength) {
        finalFlatSheets.push({
          count: 1,
          sheetTemplate: flatSheet,
        });
      } else {
        let isMatchingCutComposition = false;
        for (let i = 0; i < flatSheet.pieces.length; i++) {
          let currentFlatPiece = flatSheet.pieces[i];
          let previousSheetPiece = previousSheet.pieces[i];

          if (
            currentFlatPiece.name == previousSheetPiece.name &&
            currentFlatPiece.stretchOut == previousSheetPiece.stretchOut
          ) {
            isMatchingCutComposition = true;
          } else {
            isMatchingCutComposition = false;
            break;
          }
        }

        if (isMatchingCutComposition) {
          let finalFlatSheetsLastElementIndex = finalFlatSheets.length - 1;

          // If match, increment count by 1
          finalFlatSheets[finalFlatSheetsLastElementIndex] = {
            ...finalFlatSheets[finalFlatSheetsLastElementIndex],
            count: finalFlatSheets[finalFlatSheetsLastElementIndex].count + 1,
          };
        } else {
          finalFlatSheets.push({
            count: 1,
            sheetTemplate: flatSheet,
          });
        }
      }
    }
    previousSheet = flatSheet;
  }

  // Add Title
  let fsCount = 0;
  for (let finalFlatSheet of finalFlatSheets) {
    if (finalFlatSheet.count > 1) {
      finalFlatSheet.title = `FS #${fsCount + 1}-${
        fsCount + finalFlatSheet.count
      } (${finalFlatSheet.count})`;
      fsCount += finalFlatSheet.count;
    } else {
      fsCount++;
      finalFlatSheet.title = `FS #${fsCount}`;
    }
  }

  return {
    // flatSheetsForShearing: sheetsCopy,
    flatSheetsForShearing: finalFlatSheets,
    shearingInstructions: instructions,
  };
};

export default getShearingData;
